import React from 'react'
import styled from 'styled-components'
import { containerDefaultStyles } from 'styles/defaults'
import { Link } from 'gatsby'
import FooterLinks from 'components/FooterLinks'
import LogoIcon from 'images/header/main-logo.svg'
import mediaQuery from 'styles/mediaQuery'

const Section = styled.footer`
  padding: 40px 0;

  ${mediaQuery.mobile} {
    padding-top: 10px;
  }
`

const SectionContainer = styled.div`
  ${containerDefaultStyles};
`

const Copyright = styled.p`
  white-space: nowrap;
  font-size: 15px;
  margin-top: 100px;
  font-weight: 500;

  ${mediaQuery.mobile} {
    font-size: 10px;
  }
`

const Logo = styled(LogoIcon)`
  width: 67px;
  height: 34.9px;
  margin-bottom: 40px;
`

const Footer = () => (
  <Section>
    <SectionContainer>
      <Link to="/" aria-label="Home">
        <Logo />
      </Link>
      <FooterLinks />
      <Copyright>
        All Rights Reserved {new Date().getFullYear()} Flip.
      </Copyright>
    </SectionContainer>
  </Section>
)

export default Footer
